exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (min-width:768px){.cross-early-birds{border-top:none}}@media (min-width:576px){.cross-early-birds .cross-eb-carousel{margin:0 auto;position:relative;width:80%}}", ""]);

